import { useTranslation } from "react-i18next";

interface LineInfoProps {
  lineId?: string;
  lineNumber?: string;
  lineName?: string;
  factory?: string;
  machineCount?: number;
  lineType?: string;
  supervisor?: string;
  oemNumbers?: string[]; // OEM number is on the line (single value, kept as array for backwards compatibility)
}

const DEFAULT_LINE_INFO = {
  id: "TP01",
  name: "Production Line Alpha",
  factory: "1201 (Factory Name)",
  machineCount: 4,
  supervisor: "John Smith",
};

const LineInfo = ({
  lineId = DEFAULT_LINE_INFO.id,
  lineNumber,
  lineName = DEFAULT_LINE_INFO.name,
  factory = DEFAULT_LINE_INFO.factory,
  machineCount = DEFAULT_LINE_INFO.machineCount,
  oemNumbers,
}: LineInfoProps) => {
  const { t } = useTranslation();
  // OEM number is now a single value on the line (first element of array if provided)
  const oemDisplay = oemNumbers?.[0] || null;

  return (
    <div className="flex-1 text-white">
      <div className="text-lg md:text-2xl font-extrabold tracking-wide mb-1 md:mb-2">
        {lineNumber || lineId}
      </div>
      <div className="space-y-0.5 md:space-y-1 text-cockpitblue-light/90 text-sm md:text-lg font-mono">
        <div>
          <span className="font-semibold text-white">{t("type")}:</span>{" "}
          {lineName}
        </div>
        <div>
          <span className="font-semibold text-white">Machines:</span>{" "}
          {machineCount}
        </div>
        {oemDisplay && (
          <div>
            <span className="font-semibold text-white">OEM:</span> {oemDisplay}
          </div>
        )}
        <div>
          <span className="font-semibold text-white">Factory:</span> {factory}
        </div>
      </div>
    </div>
  );
};

export default LineInfo;
